<template>
  <label
    class="flex cursor-pointer items-center select-none"
    :class="`${props.labelClass} ${props.error && 'text-link-red'}`"
  >
    <input
      class="float-left mr-1 h-4 w-4 cursor-pointer rounded-sm border border-gray-300 bg-white bg-contain bg-center bg-no-repeat transition duration-200 checked:border-link-blue checked:bg-link-blue focus:outline-none"
      type="radio"
      :value="props.value"
      v-model="modelValue"
      :disabled="disabled"
      :name="props.name || props.id"
      :id="props.id || props.name"
    />
    {{ props.label }}
  </label>
</template>

<script setup lang="ts">
import { computed } from "vue";

type Props = {
  id?: string;
  name?: string;
  label?: string;
  labelClass?: string;
  tooltip?: string;
  modelValue: string;
  value: string | number;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
};

const props = withDefaults(defineProps<Props>(), {
  id: "",
  name: "",
  label: "",
  labelClass: "",
  tooltip: "",
  modelValue: "",
  disabled: false,
  required: false,
  error: false,
});

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emit("update:modelValue", value);
  },
});

const emit = defineEmits(["update:modelValue"]);
</script>

<style>
.tooltip .tooltip-inner {
  background: black;
  color: white;
  border: 1px solid black;
  border-radius: 2px;
  padding: 5px 10px 4px;
}
</style>
